import React from 'react';
import { Search } from 'lucide-react';
import CustomSelect from '../../ui/CustomSelect';

interface ScoringModelFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterStatus: string;
  onStatusChange: (value: string) => void;
  filterCreditType: string;
  onCreditTypeChange: (value: string) => void;
}

export default function ScoringModelFilters({
  searchTerm,
  onSearchChange,
  filterStatus,
  onStatusChange,
  filterCreditType,
  onCreditTypeChange,
}: ScoringModelFiltersProps) {
  return (
    <div className="bg-white border rounded-lg p-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Cari judul model..."
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
          />
        </div>

        <CustomSelect
          value={filterStatus}
          onChange={onStatusChange}
          placeholder="Status"
          width="w-full md:w-40"
          options={[
            { value: 'all', label: 'Semua Status' },
            { value: 'draft', label: 'Draft' },
            { value: 'active', label: 'Aktif' },
            { value: 'inactive', label: 'Nonaktif' },
          ]}
        />

        <CustomSelect
          value={filterCreditType}
          onChange={onCreditTypeChange}
          placeholder="Jenis Kredit"
          width="w-full md:w-48"
          options={[
            { value: 'all', label: 'Semua Jenis' },
            { value: 'working_capital', label: 'Modal Kerja' },
            { value: 'investment', label: 'Investasi' },
            { value: 'consumer', label: 'Konsumtif' },
            { value: 'kpr', label: 'KPR' },
            { value: 'kendaraan', label: 'Kendaraan' },
            { value: 'multiguna', label: 'Multiguna' },
          ]}
        />
      </div>
    </div>
  );
}
